package com.nonopn.skydome.common.app.api.model

import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import com.nonopn.skydome.common.app.detection.ThunderDetection


import kotlinx.serialization.Serializable

@Serializable
data class DashboardImpactReportV2(
    /**
     * Represents the corresponding probe information, null is for the total
     */
    val probe: ThunderDetection? = null,
    val periods: Map<DashboardImpactPeriod, PeriodReport>,
    val top10days: Map<String, NegPosCount>,
) {
    @Serializable
    enum class DashboardImpactPeriod(
        val headerBackgroundStart: Color,
        val headerBackgroundStop: Color,
        val title: String
    ) {
        Today(
            headerBackgroundStart = Color(0xff1e3a5f),
            headerBackgroundStop = Color(0xff1e4a7a),
            title = "⚡ Aujourd'hui — %s"
        ),
        Last30Days(
            headerBackgroundStart = Color(0xff14432a),
            headerBackgroundStop = Color(0xff1a5c38),
            title = "\uD83D\uDCC5 30 derniers jours"
        ),
        Last90Days(
            headerBackgroundStart = Color(0xff3a1455),
            headerBackgroundStop = Color(0xff4d1a70),
            title = "\uD83D\uDCC6 90 derniers jours"
        ),
        Last12Years(
            headerBackgroundStart = Color(0xff4a200f),
            headerBackgroundStop = Color(0xff6b2e12),
            title = "\uD83D\uDCCA 1 an — 12 derniers mois"
        );

        val background =
            Brush.horizontalGradient(colors = listOf(headerBackgroundStart, headerBackgroundStop))
    }

    @Serializable
    data class PeriodReport(
        val count: NegPosCount,
        val intensities: Map<IntensityDistributions, NegPosCount>,
        /**
         * Represents the mathematic report for the period, null is when no relevant information
         * were available ~> no data
         */
        val math: MathReport? = null,
        /**
         * Represents the butterfly information to show, null is when we don't want this graph
         */
        val butterFly: Map<String, NegPosCount>? = null,
    )

    @Serializable
    enum class IntensityDistributions(val text: String) {
        Less25kA("0-25 kA"),
        Less50kA("25-50 kA"),
        Less75kA("50-75 kA"),
        MoreThan75kA(">75 kA")
    }

    @Serializable
    data class NegPosCount(
        val negative: Int,
        val positive: Int,
    ) {
        fun total() = negative + positive
    }

    @Serializable
    data class MathReport(
        val minIntensity: Long,
        val maxIntensity: Long,
        val avgPosIntensity: Double,
        val avgNegIntensity: Double,
        /**
         * Represents the date to show for the min(negative) impact detected, null when
         * nothing needs to be shown
         */
        val timestampMinSeconds: Long? = null,
        /**
         * Represents the date to show for the max (positive) impact detected, null when
         * nothing needs to be shown
         */
        val timestampMaxSeconds: Long? = null,
    )
}
